"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElasticsearchQueryForFilters = void 0;
const tslib_1 = require("tslib");
const groupBy_1 = tslib_1.__importDefault(require("lodash/groupBy"));
const __enums_1 = require("../../../__types/__enums");
const getTermsQuery = (field, fieldValues) => {
    if (field === 'companyId') {
        return {
            bool: {
                should: [{ terms: { [field]: fieldValues } }, { terms: { childCompanyIds: fieldValues } }],
                minimum_should_match: 1
            }
        };
    }
    return {
        terms: {
            [field]: fieldValues
        }
    };
};
const getRangeQuery = (field, gte, lte) => {
    if (gte === '') {
        gte = null;
    }
    if (lte === '') {
        lte = null;
    }
    return {
        range: {
            [field]: {
                gte,
                lte
            }
        }
    };
};
const getNestedQueryForPath = (nestedFiltersByPath, path) => {
    const innerQuery = { bool: {} };
    const innerFilters = nestedFiltersByPath[path];
    innerQuery.bool.must = innerFilters.map((filter) => getTermsQuery(filter.name, filter.values));
    return { nested: { path, query: innerQuery } };
};
function getElasticsearchQueryForFilters(filters = []) {
    const groupedFilters = groupBy_1.default(filters, 'type');
    const query = { bool: {} };
    let mustArray = [];
    let mustNotArray = [];
    Object.keys(groupedFilters).forEach(type => {
        if (type === __enums_1.ElasticsearchFilterTypeEnum.SHOULD) {
            query.bool[type] = groupedFilters[type].map((filter) => getTermsQuery(filter.name, filter.values));
            query.bool.minimum_should_match = 1;
        }
        else if (type === __enums_1.ElasticsearchFilterTypeEnum.NESTED) {
            const nestedFilters = groupedFilters[type];
            const nestedFiltersByPaths = groupBy_1.default(nestedFilters, filter => filter.name.split('.')[0]);
            mustArray = mustArray.concat(Object.keys(nestedFiltersByPaths).map(path => getNestedQueryForPath(nestedFiltersByPaths, path)));
        }
        else if (type === __enums_1.ElasticsearchFilterTypeEnum.MUST) {
            mustArray = mustArray.concat(groupedFilters[type].map((filter) => getTermsQuery(filter.name, filter.values)));
        }
        else if (type === __enums_1.ElasticsearchFilterTypeEnum.RANGE) {
            mustArray = mustArray.concat(groupedFilters[type].map((filter) => getRangeQuery(filter.name, filter.gte, filter.lte)));
        }
        else if (type === __enums_1.ElasticsearchFilterTypeEnum.MUST_NOT) {
            mustNotArray = mustNotArray.concat(groupedFilters[type].map((filter) => getTermsQuery(filter.name, filter.values)));
        }
        if (mustArray.length > 0) {
            query.bool[__enums_1.ElasticsearchFilterTypeEnum.MUST] = mustArray;
        }
        if (mustNotArray.length > 0) {
            query.bool[__enums_1.ElasticsearchFilterTypeEnum.MUST_NOT] = mustNotArray;
        }
    });
    return query;
}
exports.getElasticsearchQueryForFilters = getElasticsearchQueryForFilters;
//# sourceMappingURL=getElasticsearchQueryFromFilters.js.map